var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warpper"},[_c('DesktopMT4'),_c('MacMT4'),_c('IpadMT4'),_c('MobileMT4')],1)}
var staticRenderFns = []

export { render, staticRenderFns }